import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/**
 * Facebook in-stream reels: the ad plays inside somebody else's post. The post
 * is a grey skeleton; the creative and the link card under it are the ad.
 */
@Component({
  selector: 'app-meta-facebook-in-stream-reels',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './facebook-in-stream-reels.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './facebook-in-stream-reels.component.scss'
})
export class MetaFacebookInStreamReelsPreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly avatar = MetaPreviewCopy.AVATAR;

  get primaryText(): string {
    return MetaPreviewCopy.flat(MetaPreviewCopy.primaryText(this.data));
  }

  get headline(): string {
    return MetaPreviewCopy.headline(this.data);
  }

  get domain(): string {
    return MetaPreviewCopy.domain(this.data);
  }
}
